import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2GpsIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 32.499 47.5",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 47.5),
    children: /*#__PURE__*/jsxs("g", {
      transform: "translate(-3.25 .5)",
      children: [/*#__PURE__*/jsx("circle", {
        cx: "19.5",
        cy: "15.75",
        r: "7.5"
      }), /*#__PURE__*/jsx("path", {
        d: "M19.5.75a15 15 0 0115 15c0 6.814-10.148 23.9-13.75 29.329a1.5 1.5 0 01-2.5 0C14.648 39.649 4.5 22.564 4.5 15.75a15 15 0 0115-15z"
      })]
    })
  });
};

export { PM2GpsIcon };
//# sourceMappingURL=gps.js.map
